import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
});

export function formatApiError(err) {
  const detail = err?.response?.data?.detail;
  if (detail == null) return err?.message || "Bir hata oluştu. Lütfen tekrar deneyin.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  }
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function progressColor(pct) {
  if (pct >= 75) return "#16a34a"; // green
  if (pct >= 30) return "#f59e0b"; // amber
  return "#dc2626"; // red
}

export function progressClass(pct) {
  if (pct >= 75) return "progress-high";
  if (pct >= 30) return "progress-mid";
  return "progress-low";
}

export function formatNumber(n) {
  if (n == null || isNaN(n)) return "0";
  return new Intl.NumberFormat("tr-TR", {
    maximumFractionDigits: 2,
    minimumFractionDigits: 0,
  }).format(n);
}
